(() => {
  let stickyMutationObserver = null;
  let stickyResizeObserver = null;
  let observedStickyBar = null;

  function createBackToTopButton() {
    if (document.querySelector('.uo-scroll-to-top')) {
      return document.querySelector('.uo-scroll-to-top');
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'uo-scroll-to-top';
    button.setAttribute('aria-label', 'Back to top');
    button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 14.5 12 7.5l7 7" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/></svg>';
    document.body.appendChild(button);
    return button;
  }

  function setupBackToTop() {
    const button = createBackToTopButton();
    if (!button) return;

    const pageWrapper = document.querySelector('.page-wrapper');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const getScrollTop = () =>
      Math.max(window.scrollY || 0, pageWrapper?.scrollTop || 0);

    const toggleVisibility = () => {
      button.classList.toggle('is-visible', getScrollTop() > 500);
    };

    const updateStickyOffset = () => {
      const stickyBar = document.querySelector(
        'sticky-add-to-cart [ref="stickyBar"]'
      );
      const isStuck = stickyBar?.dataset.stuck === 'true';
      const offset = isStuck
        ? Math.ceil(stickyBar.getBoundingClientRect().height) + 12
        : 0;

      button.style.setProperty(
        '--scroll-to-top-bottom-offset',
        `${offset}px`
      );
    };

    const observeStickyBar = () => {
      const stickyBar = document.querySelector(
        'sticky-add-to-cart [ref="stickyBar"]'
      );

      if (!stickyBar || stickyBar === observedStickyBar) {
        updateStickyOffset();
        return;
      }

      stickyMutationObserver?.disconnect();
      stickyResizeObserver?.disconnect();
      observedStickyBar = stickyBar;

      stickyMutationObserver = new MutationObserver(updateStickyOffset);
      stickyMutationObserver.observe(stickyBar, {
        attributes: true,
        attributeFilter: ['data-stuck'],
      });

      if ('ResizeObserver' in window) {
        stickyResizeObserver = new ResizeObserver(updateStickyOffset);
        stickyResizeObserver.observe(stickyBar);
      }

      updateStickyOffset();
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    pageWrapper?.addEventListener('scroll', toggleVisibility, { passive: true });
    window.addEventListener('resize', updateStickyOffset, { passive: true });

    button.addEventListener('click', () => {
      const behavior = reducedMotion.matches ? 'auto' : 'smooth';
      window.scrollTo({ top: 0, behavior });
      pageWrapper?.scrollTo({ top: 0, behavior });
    });

    toggleVisibility();
    observeStickyBar();

    window.setTimeout(observeStickyBar, 500);
    window.setTimeout(observeStickyBar, 1500);

    document.addEventListener('shopify:section:load', () => {
      observeStickyBar();
      toggleVisibility();
    });
  }

  function init() {
    setupBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
